<div
  class="base-promotional-procedures"
  *ngIf="procedures.length"
  [@fadeIn]="true"
  ngClass.lt-md="mobile"
  ngClass.gt-sm="desktop"
  fxLayout="row"
  fxLayoutAlign="center"
>
  <div fxFlex.gt-sm="66" fxFlex.lt-md="100">
    <div fxLayout="column" fxLayoutAlign="space-evenly center">
      <h2 class="head" data-cy="promotional-procedures.header">
        {{ 'promotional_procedures_head' | translate }}
      </h2>
      <p class="subhead" data-cy="promotional-procedures.sub-header">
        {{ 'promotional_procedures_subhead' | translate }}
      </p>
      <div
        class="procedures-container"
        fxLayout="row"
        data-cy="promotional-procedures.procedures-container"
      >
        <div class="procedures-list-container" fxFlex="100">
          <div class="procedures-list">
            <div
              class="procedures-list-header"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div
                class="procedures-list-title"
                data-cy="promotional-procedures.list-title"
              >
                {{ 'promotional_procedures_list_title' | translate }}
              </div>
            </div>
            <div
              class="procedure"
              *ngFor="
                let procedure of procedures;
                trackBy: trackByFnItemId;
                let i = index
              "
              [attr.data-cy]="'promotional-procedures.procedure-' + i"
              (click)="procedureSearch(procedure.id)"
              (keydown.enter)="procedureSearch(procedure.id)"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              tabindex="0"
              appGtm
              [gtmOnClick]="true"
              [gtmData]="{
                event: 'gtm.promotional_procedures.terminal_procedure',
                promotional_procedure_name: procedure.name
              }"
            >
              <div class="procedure-name-container">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <img
                    class="svg-icon"
                    [attr.data-cy]="'promotional-procedures.procedure-svg-' + i"
                    src="/assets/images/procedure-cost.svg"
                  />
                  <span
                    class="procedure-name link-blue"
                    *ngIf="procedure?.locale_name"
                    >{{ procedure.locale_name }}</span
                  >
                  <span
                    class="procedure-name link-blue"
                    *ngIf="!procedure?.locale_name"
                    >{{ procedure.name }}</span
                  >
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <zelis-button
                  class="hidden md:block"
                  variant="stroked"
                  [attr.data-cy]="'promotional-procedures.cost-button-' + i"
                  color="accent"
                >
                  {{ 'promotional_benefits_get_cost' | translate }}
                </zelis-button>
                <mat-icon
                  svgIcon="dls-angle-plain-right-light"
                  class="right-arrow-icon link-blue"
                ></mat-icon>
              </div>
            </div>
          </div>

          <div
            class="view-all-button-container pad top-3x bottom-3x"
            fxLayout="row"
            fxLayoutAlign="space-around center"
          >
            <zelis-button
              class="view-all-button"
              variant="flat"
              color="accent"
              (clickFn)="openGuidedSearchProcedures()"
              (keydown.enter)="openGuidedSearchProcedures()"
              appGtm
              [gtmOnClick]="true"
              [gtmData]="{ event: 'gtm.promotional_procedures.view_all' }"
            >
              {{ 'promotional_procedures_view_all' | translate }}
            </zelis-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
